import AnalyticsTab from '../../components/dashboard/AnalyticsTab';
import React from 'react';

const AnalyticsPage = () => <AnalyticsTab />;

export default AnalyticsPage;
